// 내 소속 목록 — basicinfo-service 의 GET /api/basicinfo/me/affiliations (게이트웨이 경유).
// 경로 규칙은 scope.ts 와 같다: 게이트웨이가 서빙하는 origin 에서만 절대 URL, 로컬은 dev 프록시 상대경로.
import { GW_ORIGIN } from 'yukimushi-component-fe';
import { authorizedFetch } from './auth';
import { normalizeAffiliations } from '../lib/affiliation';
import type { Affiliation } from '../lib/affiliation';

const SERVED_BY_GATEWAY = window.location.hostname.indexOf('gennolab.co.jp') >= 0;
const BASE = `${SERVED_BY_GATEWAY ? GW_ORIGIN : ''}/chat-api/api/basicinfo`;

/** 사원이 속한 모든 회사의 유효 소속(주소속 먼저). 실패하면 던진다 — 호출부가 조용히 생략한다 */
export async function fetchMyAffiliations(): Promise<Affiliation[]> {
  const res = await authorizedFetch(`${BASE}/me/affiliations`);
  if (!res.ok) throw new Error(`me/affiliations ${res.status}`);
  return normalizeAffiliations(await res.json());
}
